/** Where the reason a session ended waits for the sign-in page (sessionStorage: one tab, gone when it closes). */
export const SESSION_ENDED_KEY = 'session_ended_reason';

type Body = { code?: string; reason?: string; data?: { code?: string; reason?: string } };
type ErrorWithBody = { response?: { status?: number; data?: Body } };

/** The code and reason sit at the top of the body (a flat 401 or the envelope) or inside its `data`. */
const field = (error: unknown, name: 'code' | 'reason'): string | undefined => {
  const d = (error as ErrorWithBody)?.response?.data;
  return d?.[name] ?? d?.data?.[name];
};

/** The server's `401 {code: 'session_ended', reason}`: the device was signed out (see docs/api/sessions.openapi.yaml). */
export function isSessionEnded(error: unknown): boolean {
  return (error as ErrorWithBody)?.response?.status === 401 && field(error, 'code') === 'session_ended';
}

export function sessionEndedReason(error: unknown): string {
  return field(error, 'reason') ?? 'signed_out';
}

/** Read the reason once: it is forgotten as it is shown. */
export function takeSessionEndedReason(): string | null {
  try {
    const reason = window.sessionStorage.getItem(SESSION_ENDED_KEY);
    window.sessionStorage.removeItem(SESSION_ENDED_KEY);
    return reason;
  } catch {
    return null;
  }
}
